class RequestQueue {
    constructor(options) {
        const defaults = {
            'cancelRequest': function(request) {
                if(typeof request.abort !== 'function')
                    return;

                request.abort();
            }
        };
        if (typeof options === 'undefined')
            options = {};

        this.options = {...defaults, ...options};

        this.queue = [];
        this.time = new Date().getTime();
    }

    add(item) {
        this.queue.push(item);
    }

    checkTime(time) {
        if (this.time > time)
            return false;

        this.time = time;
        return true;
    }

    clear(time) {
        const self = this;
        if (typeof time === 'undefined')
            time = new Date().getTime();

        const queue = [];
        this.queue.forEach((item) => {
            if(time > item.time){
                self.options.cancelRequest(item.request);
                return;
            }

            queue.push(item)
        });
        this.queue = queue;
    }
}

class RequestManager {
    constructor(options) {
        const defaults = {
            'delay': 500,
            'cancelRequest': function(request) {
                if(typeof request.abort !== 'function')
                    return;

                request.abort();
            },
            'makeRequest' : () => {},
            'getData': () => {},
            'forceFirst': false,
            'queue': new RequestQueue()
        };

        if (typeof options === 'undefined')
            options = {};

        this.options = {...defaults, ...options};

        this.counter = 0;
        this.data = this.options.getData();
    }

    checkTime() {
        return this.options.queue.checkTime.apply(this.options.queue, arguments);
    }

    handle(ev, force) {
        const self = this;
        const data = this.options.getData();
        if (typeof force === 'undefined')
            force = false;

        if (!force && !(this.options.forceFirst && 0 === this.counter) && this.data === data)
            return;

        this.counter++;
        this.data = data;

        setTimeout(function() {
            if (self.data !== data)
                return;

            const time = new Date().getTime();
            const request = self.options.makeRequest(ev, self.data, time);
            if ('undefined' !== typeof request)
                self.options.queue.add({ 'time': time, 'request': request });

        }, this.options.delay);
    }
}